// FLAGS: none
// Maps the API's structured sign-up failure codes to translation keys.
import { isAxiosError } from "axios";
import { ResponseConveneConveneErrorResponse } from "@src/api/v1/data-contracts";

const KEY_BY_CODE: Record<string, string> = {
  SIGNUP_CLOSED: "HostSignups.Error.SignupClosed",
  SESSION_CANCELLED: "HostSignups.Error.SessionCancelled",
  SESSION_ENDED: "HostSignups.Error.SessionEnded",
  ALREADY_SIGNED_UP: "HostSignups.Error.AlreadySignedUp",
  NOT_SIGNED_UP: "HostSignups.Error.NotSignedUp",
  SESSION_NOT_FOUND: "HostSignups.Error.SessionNotFound",
};

const hostSignupErrorKey = (error: unknown): string => {
  if (isAxiosError(error)) {
    const body = error.response?.data as
      | Partial<ResponseConveneConveneErrorResponse>
      | undefined;
    const code = body?.code;
    if (code && KEY_BY_CODE[code]) {
      return KEY_BY_CODE[code];
    }
  }
  return "HostSignups.Error.Generic";
};

export default hostSignupErrorKey;
